import { ChangeDetectionStrategy, Component, computed, inject, input, model, signal } from '@angular/core';
import { HlmAutocompleteImports } from '@spartan-ng/helm/autocomplete';
import { TenantSwitcherStore } from './tenant-switcher-store';
import { OrganizationModel } from 'src/app/services/organization';
import { HlmCommandImports } from '@spartan-ng/helm/command';

@Component({
  selector: 'app-tenant-switcher',
  imports: [HlmAutocompleteImports, HlmCommandImports],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
		<hlm-command-dialog [state]="state()" (stateChange)="stateChanged($event)">
			<hlm-command>
				<hlm-command-input placeholder="Search a tenant..." />
				<hlm-command-list>
					<div *hlmCommandEmptyState hlmCommandEmpty>No results found.</div>
          <hlm-command-group>
            <hlm-command-group-label>
              The current tenant is:<strong class="pl-1">{{currentTenantName()}}</strong>
            </hlm-command-group-label>
            <button hlm-command-item value="{{defaultTenantName()}}" (selected)="reset()">
              Reset to default
            </button>
					</hlm-command-group>
					<hlm-command-separator />
					<hlm-command-group>
						<hlm-command-group-label>Select a tenant</hlm-command-group-label>
            @for(item of organizations(); track item.organizationName){
              <button hlm-command-item value="{{item.organizationName}}" (selected)="selected(item)">
                {{item.organizationName}}
              </button>
            }
					</hlm-command-group>
				</hlm-command-list>
			</hlm-command>
		</hlm-command-dialog>
	`,
})
export class TenantSwitcher {

  private readonly store = inject(TenantSwitcherStore);

	public readonly state = model.required<'closed' | 'open'>();
  
  protected readonly defaultTenantName = computed(()=>{
    return this.store.defaultTenant()?.organizationName;
  });
  protected readonly currentTenantName = computed(()=>{
    return this.store.currentTenant()?.organizationName;
  });
  protected readonly organizations = computed(()=>{
    return this.store.organizations();
  });

  constructor(){
    if(this.organizations().length===0){
      this.store.fetchOrgs();
    }
  }
  
	protected stateChanged(state: 'open' | 'closed') {
		this.state.set(state);
	}

	protected selected(org: OrganizationModel) {
		this.state.set('closed');
    this.store.setTenant(org)
	}

  protected reset(){
    this.state.set('closed');
    this.store.resetDefaultTenant();
  }

}
